import { BackToSettingsButton } from "@/setup/connect/settings-connect-layout"
import { ConnectBolEmailSyncPage } from "@/setup/connect/bol-email-sync/page"
import { ConnectGfiPage } from "@/setup/connect/gfi/page.tsx"
import { ConnectThrivePage } from "@/setup/connect/thrive/page.tsx"
import { ConnectSouthernGlazerPage } from "@/setup/connect/southern-glazer/page.tsx"
import { ConnectVitaminShoppePage } from "@/setup/connect/vitamin-shoppe/page.tsx"
import { ConnectWincoPage } from "@/setup/connect/winco/page.tsx"
import { ConnectMuscleFoodsPage } from "@/setup/connect/muscle-foods/page.tsx"
import { ConnectCostcoPage } from "@/setup/connect/costco/page.tsx"
import { ConnectEmailRemittancePage } from "@/setup/connect/email-remittance/page.tsx"
import { ConnectCoreMarkPage } from "@/setup/connect/core-mark/page.tsx"
import { ConnectAlbertsonsPage } from "@/setup/connect/albertsons/page.tsx"
import { ConnectBillPage } from "@/setup/connect/bill/page.tsx"
import { ConnectGoogleDrivePage } from "@/setup/connect/googledrive/page"
import { ConnectNetsuitePage } from "@/setup/connect/netsuite/page"
import { OAuthConnectPage } from "@/setup/connect/oauth-connect-page"
import { SageConnectForm } from "@/setup/connect/sage/sage_connect_form"

export function SettingsConnectQuickbooksPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <OAuthConnectPage provider="quickbooks" displayName="Quickbooks" returnPath="/settings/accounting" />
    </div>
  )
}

export function SettingsConnectXeroPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <OAuthConnectPage provider="xero" displayName="Xero" returnPath="/settings/accounting" />
    </div>
  )
}

export function SettingsConnectSageIntacctPage() {
  // Sage connects with client credentials, not OAuth — see SageConnectForm.
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <SageConnectForm redirectTo="/settings/accounting" />
    </div>
  )
}

export function SettingsConnectNetsuitePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectNetsuitePage returnPath="/settings/accounting" />
    </div>
  )
}

export function SettingsConnectGoogleDrivePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectGoogleDrivePage />
    </div>
  )
}

export function SettingsConnectBolEmailSyncPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectBolEmailSyncPage redirectTo="/settings/connect#logistics" />
    </div>
  )
}

export function SettingsConnectGfiPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectGfiPage redirectTo="/settings/connect#distributor" />
    </div>
  )
}

export function SettingsConnectThrivePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectThrivePage redirectTo="/settings/connect#retailer" />
    </div>
  )
}

export function SettingsConnectSouthernGlazerPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectSouthernGlazerPage redirectTo="/settings/connect#distributor" />
    </div>
  )
}

export function SettingsConnectVitaminShoppePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectVitaminShoppePage redirectTo="/settings/connect#retailer" />
    </div>
  )
}

export function SettingsConnectWincoPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectWincoPage redirectTo="/settings/connect#retailer" />
    </div>
  )
}

export function SettingsConnectCostcoPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectCostcoPage redirectTo="/settings/connect#retailer" />
    </div>
  )
}

export function SettingsConnectEmailRemittancePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectEmailRemittancePage redirectTo="/settings/connect#distributor" />
    </div>
  )
}

export function SettingsConnectMuscleFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectMuscleFoodsPage redirectTo="/settings/connect#distributor" />
    </div>
  )
}

export function SettingsConnectAlbertsonsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectAlbertsonsPage redirectTo="/settings/connect#retailer" />
    </div>
  )
}

export function SettingsConnectCoreMarkPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectCoreMarkPage redirectTo="/settings/connect#distributor" />
    </div>
  )
}

export function SettingsConnectBillPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectBillPage redirectTo="/settings/connect#accounting" />
    </div>
  )
}
